module.exports = __webpack_public_path__ + "static/img/banner.63826a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner.png
// module id = 91
// module chunks = 1